import React from "react";

const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 256 256"
      width="36px"
      height="36px"
    >
      <g
        fill="none"
        fillRule="nonzero"
        stroke="#f0f8ff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
        textAnchor="none"
        // style="mix-blend-mode: normal"
      >
        <g transform="scale(4,4)">
          <path d="M41.713,26.5c-2.627,-1.598 -4.409,-0.986 -5.414,-0.24c-0.7,0.519 -1.644,0.551 -2.331,0.015l-0.127,-0.099c-0.903,-0.706 -0.968,-2.053 -0.14,-2.846c2.255,-2.16 5.013,-1.928 6.76,-1.443c1.158,0.321 2.366,-0.31 2.815,-1.425v0c0.408,-0.95 -0.048,-2.063 -1.018,-2.423c-2.635,-0.978 -7.807,-2.059 -12.043,2.177c-5.958,5.958 -3.024,13.585 -0.542,16.88c2.441,3.24 10.787,9.614 19.724,2.212c10.028,-8.306 4.513,-18.686 1.083,-22.116c-3.114,-3.114 -14.127,-9.794 -23.921,0c-8.076,8.076 -3.669,17.888 -1.356,21.793c-5.459,2.805 -18.984,13.17 -14.742,17.413c4.242,4.243 17.271,-14.563 17.271,-14.563c0,0 4.875,4.333 9.207,4.243"></path>
        </g>
      </g>
    </svg>
  );
};

export { SearchIcon };
